import { memo, useContext, useState } from "react";
import {
  BLACK,
  ECoordinateTransformMode,
  toolBoxIcon_1,
  toolBoxIcon_2,
  toolBoxIcon_3,
  WHITE,
} from "../../config/componentsConfig";

import HelmContext from "../Contexts/HelmContext";
import { HelmInputContent } from "./HelmInputContent";
import { HelmTransformContent } from "./HelmTransformContent";
import { HelmVerificationContent } from "./HelmVerificationContent";
import GridCoordinatePoint from "../HelmartTransform/GridCoordinatePoint";
import { Box, SvgIcon, useTheme } from "@mui/material";
import { t } from "i18next";
import Q3DIconButton from "../../Parts/Q3DIconButton";

type Props = {};

const HelmContent = () => {
  const { currentHelmTab } = useContext(HelmContext);

  switch (currentHelmTab) {
    case ECoordinateTransformMode.INPUT:
      return <HelmInputContent />;
    case ECoordinateTransformMode.TRANSFORM:
      return <HelmTransformContent />;
    case ECoordinateTransformMode.VERIFICATION:
      return <HelmVerificationContent />;
    default:
      return;
  }
};

export const HelmDrawerContent = memo((props: Props) => {
  const { coordinatePoints } = useContext(HelmContext);
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", flexDirection: "row", height: "95%" }}>
      {HelmContent()}
      <GridCoordinatePoint
        gridRowCol={coordinatePoints}
        height={"100%"}
        open={open}
      />
      <Q3DIconButton
        title={t("SHOW_HIDE")}
        onClick={(e) => {
          setOpen(!open);
        }}
        icon={
          <SvgIcon sx={{ backgroundColor: theme.palette.base.main }}>
            <path d={toolBoxIcon_1} fill={BLACK} />
            <path d={toolBoxIcon_2} fill={WHITE} />
            <path d={toolBoxIcon_3} fill={WHITE} />
          </SvgIcon>
        }
        sx={{
          position: "absolute",
          bottom: "20px",
          right: "12px",
          zIndex: 100,
        }}
      />
    </Box>
  );
});
